import { Haptics, ImpactStyle } from '@capacitor/haptics'

import { motion } from "framer-motion"
import { PiArrowLeft } from "react-icons/pi"
import { useNavigate } from "react-router-dom"

import { isIphone } from "@/utils/device"

interface HeaderBackProps {
  children?: React.ReactNode
  to?: string
  className?: string
}

const HeaderBack = ({
  children,
  to,
  className = `px-[1.12rem] pb-4 ${isIphone ? 'pt-1' : 'pt-3'}`
}: HeaderBackProps) => {
  const navigate = useNavigate()

  return (
    <motion.div className={`flex flex-row ${className}`}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center justify-center rounded-full bg-zinc-100 p-2"
        onClick={() => {
          to ? navigate(to) : navigate(-1)
          Haptics.impact({ style: ImpactStyle.Light })
        }}
      >
        <PiArrowLeft className="w-5 h-5" />
      </div>
      {children}
    </motion.div>
  )
}

export default HeaderBack